export default __webpack_public_path__ + "resources/icons/d420-a65a.webp";